

export class PoiAlertSpecificationInput implements IPoiAlertSpecificationInput {
    /** The auto-generated id of the poi master */
    poiDetailsId!: number;

    constructor(data?: IPoiAlertSpecificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiDetailsId = _data["poiDetailsId"];
        }
    }

    static fromJS(data: any): PoiAlertSpecificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiAlertSpecificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiDetailsId"] = this.poiDetailsId;
        return data; 
    }
}

export interface IPoiAlertSpecificationInput {
    /** The auto-generated id of the poi master */
    poiDetailsId: number;
}

